/**
 * @param BasicInput Base widget for extending
 * @returns Input File class
 */
function InputFileClassCreator(BasicInput: import('widgets/forms/BasicInput').TBasicInput) {
    /**
     * @category widgets
     * @subcategory forms
     * @class InputFile
     * @augments BasicInput
     * @classdesc Widget used to handle file inputs.
     */
    class TInputFile extends BasicInput {
        /**
         * @description Get input value
         * @returns - return input name
         */
        getFiles(): FileList | null | undefined {
            return this.ref('field').get<HTMLInputElement>()?.files;
        }
    }

    return TInputFile;
}

export type TInputFile = ReturnType<typeof InputFileClassCreator>;

export type TInputFileInstance = InstanceType<TInputFile>;

export default InputFileClassCreator;
